// Copyright (c) 2016 Deere & Company

import BasicWarrantyEstimator from '../../../reports/basic-warranty-estimator/state-connector';

export default {
    component: BasicWarrantyEstimator,
    name: 'BASIC_WARRANTY_ESTIMATOR',
    path: 'basic-warranty-estimator'
};



// WEBPACK FOOTER //
// ./src/routes/products/reports/basic-warranty-estimator.js